import { render, staticRenderFns } from "./queryForm.vue?vue&type=template&id=13c32120&scoped=true"
import script from "./queryForm.vue?vue&type=script&lang=js"
export * from "./queryForm.vue?vue&type=script&lang=js"
import style0 from "./queryForm.vue?vue&type=style&index=0&id=13c32120&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c32120",
  null
  
)

export default component.exports